import styled from 'styled-components';


const Root = styled.div`
	display: inline-block;
	position: relative;
`;

const ButtonStyled = styled.div`
	background-color: rgba(62, 71, 87, 0.47);
	padding: 5px;
	margin: 0;
	width: 30px;
	height: 30px;
	border-radius: 2px;
	outline: none;
	cursor: pointer;
	transition: background-color .2s ease-in-out;

	&:hover {
		background-color: rgba(62, 71, 87, 0.8);
	}
`;

const ButtonSign = styled.div`
	font-size: 12px;
	letter-spacing: 1px;
	text-align: center;
	margin-top: 3px;
	color: rgba(0, 0, 0, 0.45);
`;

const rootStyle = {
	width: 36,
	height: 36,
	padding: 4
};

const rootIconStyle = {
	width: 28,
	height: 28
};

export {
	Root,
	ButtonStyled,
	ButtonSign,
	rootStyle,
	rootIconStyle
}